import type { AxiosInstance, InternalAxiosRequestConfig } from "axios";

const ocpApimSubscriptionKeyHeaderInterceptor = (config: InternalAxiosRequestConfig) => {
    config.headers.set("Ocp-Apim-Subscription-Key", environment.settings["Integrations:SAG:PublicSubscriptionKey"]);
    return config;
};

export const addSagAuthInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(ocpApimSubscriptionKeyHeaderInterceptor);
};
